import {debounce} from '../utils/functions';
export const mainBarNav = () => {
    const bskMainBar = document.querySelector(".bsk-main-bar");
    const hamburger = document.querySelector(".bsk-main-bar__hamburger");
    const btnBackToTop = document.querySelector('.bsk-btn-back-to-top');
    const body = document.body;
    const bskMainBarMenu = document.querySelector(".bsk-main-bar__menu");
    const closeMenu = () => {
        hamburger.classList.remove("bsk-main-bar__hamburger--active");
        debounce(() => {
            bskMainBarMenu.setAttribute("hidden", "hidden");
        },250)();
    };

    const openMenu = () => {
        bskMainBarMenu.removeAttribute("hidden");
        setTimeout(() => {
            hamburger.classList.add("bsk-main-bar__hamburger--active");
        });
    };

    if(bskMainBar) {
        const bskMinBarScroll = () => {
            const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;

            if(scrollTop > 92) {
                bskMainBar.classList.add("bsk-main-bar--scroll");
                btnBackToTop.classList.add("bsk-btn-back-to-top--show");
                body.classList.add("bsk-body-scroll");
            } else {
                bskMainBar.classList.remove("bsk-main-bar--scroll");
                btnBackToTop.classList.remove("bsk-btn-back-to-top--show");
                body.classList.remove("bsk-body-scroll");
            }
        }
        bskMinBarScroll();
        window.addEventListener("scroll", bskMinBarScroll);

        hamburger?.addEventListener("click", e => {
            // e.target.classList.toggle("bsk-main-bar__hamburger--active");
            if(e.target.classList.contains("bsk-main-bar__hamburger--active")) {
                closeMenu();
            } else {
                openMenu();
            }
        });

        document.addEventListener("click", (e) => {
            const et = e.target;
            if(!et.matches(".bsk-main-bar *") && hamburger.classList.contains("bsk-main-bar__hamburger--active") && window.getComputedStyle( hamburger ).display !== "none") {
                closeMenu();
            }
        });
        document.addEventListener("focusin", e => {
            const et = e.target;
            if(!et.closest(".bsk-main-bar__menu") &&
                !et.closest(".bsk-main-bar__hamburger") &&
                window.getComputedStyle( hamburger ).display !== "none") {
                closeMenu();
            }
        });
        window.addEventListener("resize", () => {
            debounce(() => {
                if(window.getComputedStyle( hamburger ).display === "none") {
                    // desktop
                    bskMainBarMenu.removeAttribute("hidden");
                } else {
                    // mobile
                    if(hamburger.classList.contains("bsk-main-bar__hamburger--active")) {
                        bskMainBarMenu.removeAttribute("hidden");
                    } else {
                        bskMainBarMenu.setAttribute("hidden", "hidden");
                    }
                }
            },200)();
        });
        if(window.getComputedStyle( hamburger ).display !== "none") {
            closeMenu();
        }
    }

    /* Hide mobile menu by touch and mouse */
    let isDragging = false;
    let startX = 0;

    bskMainBarMenu.addEventListener('mousedown', ({ button, clientX }) => {
        if (button === 0) {
            isDragging = true;
            startX = clientX;
        }
    });

    bskMainBarMenu.addEventListener('touchstart', ({ touches }) => {
        if (touches.length === 1) {
            isDragging = true;
            startX = touches[0].clientX;
        }
    });

    bskMainBarMenu.addEventListener('mousemove', ({ buttons, clientX }) => {
        if (isDragging && buttons === 1) {
            const distance = clientX - startX;
            if (distance >= 100) {
                closeMenu();
                isDragging = false;
            }
        }
    });

    bskMainBarMenu.addEventListener('touchmove', ({ touches }) => {
        if (isDragging && touches.length === 1) {
            const distance = touches[0].clientX - startX;
            if (distance >= 100) {
                closeMenu();
                isDragging = false;
            }
        }
    });

    ['mouseup', 'touchend'].forEach((event) => {
        bskMainBarMenu.addEventListener(event, () => isDragging = false);
    });


    btnBackToTop.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
};
